<template>
  <div class="flex w-full flex-col gap-2 rounded-lg py-2.5 sm:flex-row-reverse">
    <slot />
  </div>
</template>
